import { useQuery } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect } from 'react';

import useAuth from '@/common/hooks/useAuth';
import usePermissions from '@/common/hooks/usePermissions';
import { getUserFeatures } from '@/graphql/queries/user';

import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import useStyles from './styles';

const REFRESH_DELAY = 2000;

const Layout = (props) => {
  const classes = useStyles();
  const { children } = props;
  const { onSignOut, userType, isLoggedIn, isActiveSession } = useAuth();
  const { setPermissions } = usePermissions();

  useQuery(getUserFeatures, {
    skip: !isLoggedIn,
    onCompleted: (data) => setPermissions(data?.getUserFeatures || []),
  });

  useEffect(() => {
    if (userType === 'partner') {
      onSignOut();
    }
  }, []);

  useEffect(() => {
    // user has logged out in another tab
    if (isLoggedIn && !isActiveSession) {
      // give a small delay to make sure the Cognito session has been cleared out
      setTimeout(() => window.location.reload(), REFRESH_DELAY);
    }
  }, [isLoggedIn, isActiveSession]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />
      {isLoggedIn && <Sidebar />}
      <div className={classes.content}>
        <div className={classes.appBarSpacer} />
        {children}
      </div>
    </div>
  );
};

export default Layout;
